import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';
import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
/**
 * @todo 登出
 */
const Logout = (): Promise<boolean> => {
    const url = RouteUrlList.API_Logout.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.false, getServiceAlert: ApiClient.paramTypeEnum.false }
    };
    return ApiClient.post(url, {}, config)
        .then((res: AxiosResponse<GeneralResp>) => {
            return res.data.status;
        })
        .catch((e) => {
            return false;
        });
};

export default Logout;
